









import Vue from 'vue'
export default Vue.extend({
  props: {
    noMargin: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    num () {
      if (this.$store.state.user.user && this.$store.state.user.user.data && this.$store.state.user.user.data.msgr && this.$store.state.user.user.data.msgr.mgs.length) {
        return 0
      }

      return 1
    }
  }
})
